export default class FileViewmodel {
    public id: number | undefined = undefined;
    public fileId: number | undefined = undefined;
    public file: File | null = null;
    public fileName: string = '';
    public description: string = '';
    public fileInBlob: boolean = true;
}